import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { CommonActions } from "@react-navigation/routers";
export var NOT_INITIALIZED_ERROR = "The 'navigation' object hasn't been initialized yet. This might happen if you don't have a navigator mounted, or if the navigator hasn't finished mounting. See https://reactnavigation.org/docs/navigating-without-navigation-prop#handling-initialization for more details.";
export default function createNavigationContainerRef() {
    var methods = _to_consumable_array(Object.keys(CommonActions)).concat([
        "addListener",
        "removeListener",
        "resetRoot",
        "dispatch",
        "isFocused",
        "canGoBack",
        "getRootState",
        "getState",
        "getParent",
        "getCurrentRoute",
        "getCurrentOptions"
    ]);
    var listeners = {};
    var removeListener = function(event, callback) {
        if (listeners[event]) {
            listeners[event] = listeners[event].filter(function(cb) {
                return cb !== callback;
            });
        }
    };
    var current = null;
    var ref = _object_spread({
        get current () {
            return current;
        },
        set current (value){
            current = value;
            if (value != null) {
                Object.entries(listeners).forEach(function(param) {
                    var _param = _sliced_to_array(param, 2), event = _param[0], callbacks = _param[1];
                    callbacks.forEach(function(callback) {
                        value.addListener(event, callback);
                    });
                });
            }
        },
        isReady: function() {
            if (current == null) {
                return false;
            }
            return current.isReady();
        }
    }, methods.reduce(function(acc, name) {
        acc[name] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (current == null) {
                switch(name){
                    case "addListener":
                        {
                            var _args = _sliced_to_array(args, 2), event = _args[0], callback = _args[1];
                            listeners[event] = listeners[event] || [];
                            listeners[event].push(callback);
                            return function() {
                                return removeListener(event, callback);
                            };
                        }
                    case "removeListener":
                        {
                            var _args1 = _sliced_to_array(args, 2), event1 = _args1[0], callback1 = _args1[1];
                            removeListener(event1, callback1);
                            break;
                        }
                    default:
                        console.error(NOT_INITIALIZED_ERROR);
                }
            } else {
                var _current;
                // @ts-expect-error: this is ok
                return (_current = current)[name].apply(_current, _to_consumable_array(args));
            }
        };
        return acc;
    }, {}));
    return ref;
}
